import { ROLES } from './roles';

export const cancelSubscriptionStatusMessage =
  'Cancellation request acknowledged. Please check the email address of the registered account holder to confirm the cancellation. Any issues please contact support@securityrisk.com';

export const SECURITY_COMPANY_APPROVAL_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

export const DEFAULT_SECURITY_COMPANY_FILTER = {
  archived: false,
};

export const SECURITY_COMPANY_FULL_ACCESS = [
  ROLES.SECURITY_COMPANY_MANAGER.id,
  ROLES.SRM_EMPLOYEE.id,
];

export const SUBSCRIPTION_UNAVAILABLE =
  'Your current subscription {value}, already provides you this capability';

export const NO_CREDITCARD_MESSAGE =
  'No credit card details found. Please add credit card details in Billing section';

export const NO_CREDITCARD_TITLE = 'Please enter your credit card details';
export const NO_CREDITCARD_STRPE_MESSAGE =
  'You must enter a valid credit card to commence a trial. You will not be billed until your trial has concluded. We will notify you again prior to billing your credit card and remind you when your trial is concluding';
